import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'create_invoice',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.retail_items.push({
        id: crypto.randomUUID(),
        type_id: null,
        amount: 0,
      })
    })
  }
}
